import React, { useEffect, useState } from 'react';
import './GeometryShape.css';
import { Slider } from "@material-tailwind/react";

export default function GeometryShape({ sendGeometryShape, setShowAction , ClearFilter, shapeParams, setClearFilter_geo, handleNumpage}) {
    const [boxParams, setBoxParams] = useState(false);
    const [selectedShape, setSelectedShape] = useState("");
    const [submittedData, setSubmittedData] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => {
        setIsDropdownOpen(prev => !prev);
      };
      const [ranges, setRanges] = useState({});         // Stores range per param
      const [paramValues, setParamValues] = useState({}); // Optional, if used separately
      
      const handleMinChange = (e) => {
        const param = e.target.name;
        const newMin = e.target.value;
        const currentRange = ranges[param] || [0, 0];
        const updatedRange = [newMin, currentRange[1]];
      
        setRanges(prev => ({ ...prev, [param]: updatedRange }));
        handleParamChange(param, updatedRange); // Use updated range
      };
      
      const handleMaxChange = (e) => {
        const param = e.target.name;
        const newMax = e.target.value;
        const currentRange = ranges[param] || [0, 0];
        const updatedRange = [currentRange[0], newMax];
      
        setRanges(prev => ({ ...prev, [param]: updatedRange }));
        handleParamChange(param, updatedRange); // Use updated range
      };
      
      const handleParamChange = (name, value) => {
        setParamValues(prev => ({
          ...prev,
          [name]: value,
        }));
      };
      

      
    
   

    const [checkedItems, setCheckedItems] = useState(
        Object.keys(shapeParams).reduce((acc, shape) => ({ ...acc, [shape]: false }), {})
    );


    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
      
        setCheckedItems(prevState => ({
            ...prevState,
            [name]: checked,
        }));
    
        if (checked) {
            setSelectedShape(name); // Set the current shape for opening the box
            setShowAction(true);    // Show the box
            setBoxParams(true);
            setIsDropdownOpen(false)
        } else {
            setSubmittedData(prev => prev.filter(item => item.shape !== name));
            setSelectedShape(null);
            setShowAction(false);
            setBoxParams(false);
        }
    };
      


      const handleSubmit = () => {
        const newData = { shape: selectedShape, parameters: { ...paramValues } };
        setSubmittedData(prevData => [...prevData, newData]);
       
        setBoxParams(false);
        setSelectedShape(null);
        setParamValues({});
    };
    
  

  


 
    useEffect(() => {

        //console.log("Submitted Data:", submittedData);

            sendGeometryShape( submittedData);
      
    }, [submittedData]);

    useEffect(() => {
        

        if(ClearFilter === true){
            setIsDropdownOpen(false)
            setSubmittedData([])
            handleNumpage(1)
            setClearFilter_geo(false)
            setCheckedItems( Object.keys(shapeParams).reduce((acc, shape) => ({ ...acc, [shape]: false }), {}))
        }
      
    
    }, [ClearFilter]);




    const closeModal = () => {
      setBoxParams(false);
      setSelectedShape(null);
      setParamValues({});
  };


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.custom-select-container')) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  
    return (
        <div>
        <h2 className='Title-Geometry'>Geometry Shape</h2>
        <hr className="separator" />


       {/* <div className="dropdown-container">
            <div className="dropdown-header" onClick={toggleDropdown}>
                {Object.keys(checkedItems).filter(item => checkedItems[item]).join(', ') || "Select Shapes"}
            </div>

            {isDropdownOpen && (
                <div className="dropdown-menu">
                {Object.keys(shapeParams).map((item) => (
                    <label key={item} className="dropdown-item">
                    <input
                        type="checkbox"
                        name={item}
                        checked={checkedItems[item] || false}
                        onChange={handleCheckboxChange}
                    />
                    {item}
                    </label>
                ))}
                </div>
            )}
            </div>*/}

            <div className="custom-select-container">
                <div className="custom-select-header" onClick={toggleDropdown}>
                    {Object.keys(checkedItems).filter(item => checkedItems[item]).join(', ') || "Select Shapes"}
                    <span className="arrow">&#9662;</span>
                </div>

                {isDropdownOpen && (
                    <div className="custom-select-menu">
                    {Object.keys(shapeParams).map((item) => (
                        <label key={item} className="custom-select-item">
                        <input
                            type="checkbox"
                            name={item}
                            checked={checkedItems[item] || false}
                            onChange={handleCheckboxChange}
                        />
                        {item}
                        </label>
                    ))}
                    </div>
                )}
                </div>

            {boxParams && selectedShape && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>{selectedShape} Parameters</h3>
                        <ul>
                            {shapeParams[selectedShape].map((param, index) => (
                                <li key={index}>
                                <label>{param} (nm): </label>
                               {/*<input 
                                    type="text" 
                                    name={param} 
                                    value={paramValues[param] || ''} 
                                    onChange={handleParamChange} 
                                />*/}
                                  <div className="input-group">
                                        <div className="input-wrapper">
                                        <label htmlFor="min-input" className="input-label">Min Value:</label>
                                        <input
                                            type="text"
                                            name={param}
                                            value={ranges[param]?.[0] || ''}
                                            onChange={handleMinChange}
                                            className="input-field-slider"
                                        />
                                        </div>
                                        <div className="input-wrapper">
                                        <label htmlFor="max-input" className="input-label">Max Value:</label>
                                        <input
                                             type="text"
                                             name={param}
                                             value={ranges[param]?.[1] || ''}
                                             onChange={handleMaxChange}
                                            className="input-field-slider"
                                        />
                                        </div>
                                    </div>
                                                            
      
                                    {/*<Slider color="amber" defaultValue={50} /> */}
                                
                            
                               
                            </li>
                            ))}
                        </ul>
                        <button onClick={handleSubmit}>Submit</button>
                        <button onClick={handleSubmit}>Cancel</button>
                    </div>
                </div>
            )}
        </div>
    );
}
